<p>
  {{ 'STEP2.INTRODUCTIONTEXT' | translate }}
</p>
<div *ngFor="let thickness of allowedWallThicknesses">
  <app-isomasters-button (modularClick)="updateThickness(thickness)" [selected]="thickness === selectedThickness" class="thicknessButton">
    <div (click)="openClassification($event, thickness)" content>
      <div *ngIf="!isStandardThickness(thickness)" class="product-classification-button">
        <span *ngIf="isProThickness(thickness)"
          class="product-classification-icon">Pro</span>
        <span *ngIf="isProPlusThickness(thickness)"
          class="product-classification-icon">Pro +</span>
      </div>
    </div>
    <div description>
      <span>{{ thickness }}</span>
      <span class="light-text">mm</span>
    </div>
  </app-isomasters-button>
</div>
